import { render, staticRenderFns } from "./LogoIcons.vue?vue&type=template&id=205ef7ed&"
import script from "./LogoIcons.vue?vue&type=script&lang=js&"
export * from "./LogoIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports